import { useState, useRef, useCallback } from "react";
import { useEffectAsync } from "../utils";
import { usePagedData } from "./async-hooks";


export function useInfiniteScroll<T>(loadData: (p: { skip: number, limit: number }) => Promise<T[]>, { perPage = 10, threshold = 0.3 } : {
    perPage?: number,
    threshold?: number
}, deps: any[] = []) {

    const { data, loading, hasMore, error, loadMoreData, setData } = usePagedData(loadData, perPage, deps);

    const observer = useRef(
        new IntersectionObserver(() => { }, { threshold })
    );

    const lastElementRef = useCallback(node => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                loadMoreData();
            }
        }, { threshold: threshold })
        if (node) observer.current.observe(node);
    }, [loading, hasMore, loadData]);

    return {
        data, loading, error,
        lastElementRef,
        setData,
        loadMoreData
    }
}